import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, signal, OnInit } from '@angular/core';
import { CustomButtonComponent } from '@app/components/_ui/custom-button';
import { IconComponent } from '@app/components/_ui/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'custom-dialog-header',
    template: `
        <div class="text-2xl font-bold">
            {{ customHeader() | translate }}
        </div>
        <div class="flex flex-grow justify-center items-center">
            @if (headerMiddle()) {
                <ng-template [ngTemplateOutlet]="headerMiddle().template"></ng-template>
            }
        </div>
        @if (headerRight(); as rightItems) {
            @for (item of rightItems; track $index) {
                <div class="mr-item-xs">
                    <ng-template [ngTemplateOutlet]="item.template"></ng-template>
                </div>
            }
        }
        @if (dialogConfig.draggable) {
            <icon name="drag_indicator" class="mr-item-xs cursor-move" size="26" />
        }
        @if (dialogConfig.closable) {
            <custom-button
                class="flex items-end justify-center"
                icon="close"
                type="grey"
                iconOnly
                (click)="ref.close()" />
        }
    `,
    styles: `
        :host {
            width: 100%;
            display: flex;
            align-items: center;
            place-content: center end;
        }
    `,

    imports: [CustomButtonComponent, NgTemplateOutlet, IconComponent, TranslatePipe],
})
export class CustomDialogHeaderComponent implements OnInit {
    public dialogConfig: any = inject(DynamicDialogConfig);
    public ref: DynamicDialogRef = inject(DynamicDialogRef);

    customHeader = signal<string>('');
    headerMiddle = signal<any>(undefined);
    headerRight = signal<any[]>([]);

    ngOnInit(): void {
        this.waitForConfigProperty(
            'customHeader',
            () => (this.customHeader = this.dialogConfig['customHeader']),
        );
        this.waitForConfigProperty(
            'headerMiddle',
            () => (this.headerMiddle = this.dialogConfig['headerMiddle']),
        );
        this.waitForConfigProperty(
            'headerRight',
            () => (this.headerRight = this.dialogConfig['headerRight']),
        );
    }

    private waitForConfigProperty(
        propertyName: string,
        setterCallback: () => void,
        attempt = 0,
    ): void {
        if (this.dialogConfig[propertyName]) {
            setterCallback();
            return;
        }

        if (attempt < 300) {
            setTimeout(() => {
                this.waitForConfigProperty(propertyName, setterCallback, attempt + 1);
            }, 1);
        } else {
            console.warn(`${propertyName} not found after 300 attempts`);
        }
    }
}
